var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 264,
    viewBox: "0 0 274 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.272 211.258C193.116 211.258 237.576 166.652 237.576 111.629C237.576 56.6054 193.116 12 138.272 12C83.4284 12 38.9688 56.6054 38.9688 111.629C38.9688 166.652 83.4284 211.258 138.272 211.258Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.799 54.6992L199.963 119.178C204.477 122.844 205.122 129.529 201.253 134.057L143.004 203.927C139.35 208.456 132.686 209.102 128.173 205.221L37.252 129.313C32.7382 125.647 32.0933 118.962 35.9623 114.433L82.6048 58.3652L122.799 54.6992Z",
    fill: "#E1EAF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.796 54.6992L108.825 71.7353C106.46 74.5387 102.161 74.97 99.1522 72.3823L82.3867 58.3652L122.796 54.6992Z",
    fill: "#CED7E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_282_10173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.018 145.918L211.569 150.447L133.975 205.437C128.601 209.318 121.078 208.025 117.424 202.633L40.0452 92.6534C36.1762 87.2623 37.4659 79.7146 42.8394 76.0486L110.331 28.3906L155.469 36.1539L214.149 119.394L221.027 129.098C224.681 134.705 223.391 142.037 218.018 145.918Z",
    fill: "#F0F5FA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.474 36.1539L135.484 50.6023C132.045 53.19 127.101 52.3274 124.522 48.6614L110.336 28.3906H110.551L155.474 36.1539Z",
    fill: "#CED7E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.015 145.919L211.566 150.448V119.395H213.931L220.809 129.099C224.678 134.705 223.388 142.037 218.015 145.919Z",
    fill: "#CED7E2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_282_10173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.645 85.1108L201.684 193.797C199.749 200.051 193.086 203.717 186.853 201.56L88.624 170.723C82.3907 168.782 78.9516 162.097 80.8861 155.627L120.865 27.5331C122.8 21.2793 129.463 17.6133 135.696 19.7698L214.58 44.3535",
    fill: "#F0F5FA"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M220.169 91.3643L205.768 137.513C204.908 140.1 202.328 141.61 199.749 140.747L112.697 113.36C110.118 112.498 108.614 109.91 109.473 107.322L123.874 61.1737C124.734 58.5859 127.314 57.0764 129.893 57.939L216.945 85.3262C219.524 85.9731 221.028 88.7765 220.169 91.3643Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.643 85.1096L212 77.7776C207.916 76.4838 205.551 72.1708 206.841 67.8579L214.149 44.1367H214.364L235.643 85.1096Z",
    fill: "#E6EDF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.976 70.439L176.753 67.8513C172.239 67.42 168.8 63.3227 169.445 58.5785L172.239 32.2695H172.454L202.976 70.439Z",
    fill: "#CED7E2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_282_10173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.976 62.6762V184.085C202.976 191.202 197.388 196.809 190.295 196.809H80.4589C73.3658 196.809 67.7773 191.202 67.7773 184.085V40.6802C67.7773 33.5639 73.5808 27.957 80.4589 27.957H168.37L202.976 62.6762Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.973 62.6762L176.535 62.8918C171.806 62.8918 168.152 59.2258 168.152 54.4816V27.957H168.367L202.973 62.6762Z",
    fill: "#E1EAF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.692 128.456H95.0797C93.1452 128.456 91.6406 126.946 91.6406 125.005V76.7004C91.6406 74.7595 93.1452 73.25 95.0797 73.25H178.692C180.627 73.25 182.131 74.7595 182.131 76.7004V124.79C182.346 126.73 180.627 128.456 178.692 128.456Z",
    fill: "#E6EDF5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.004 120.91H105.184L122.594 101.07L140.004 120.91Z",
    fill: "#CED7E2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.015 120.907H118.719L143.867 92.4414L169.015 120.907Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.296 93.9482C121.976 93.9482 124.959 90.9552 124.959 87.2632C124.959 83.5711 121.976 80.5781 118.296 80.5781C114.616 80.5781 111.633 83.5711 111.633 87.2632C111.633 90.9552 114.616 93.9482 118.296 93.9482Z",
    fill: "#CED7E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.4 145.486H94.2081C92.9185 145.486 91.8438 144.408 91.8438 143.114C91.8438 141.82 92.9185 140.742 94.2081 140.742H180.4C181.69 140.742 182.764 141.82 182.764 143.114C182.764 144.408 181.69 145.486 180.4 145.486Z",
    fill: "#CED7E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.4 158.858H94.2081C92.9185 158.858 91.8438 157.779 91.8438 156.485C91.8438 155.192 92.9185 154.113 94.2081 154.113H180.4C181.69 154.113 182.764 155.192 182.764 156.485C182.764 157.779 181.69 158.858 180.4 158.858Z",
    fill: "#CED7E2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.767 169.856C136.767 171.15 135.692 172.229 134.402 172.229H94.2081C92.9185 172.229 91.8438 171.15 91.8438 169.856C91.8438 168.563 92.9185 167.484 94.2081 167.484H134.402C135.692 167.484 136.767 168.563 136.767 169.856Z",
    fill: "#CED7E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.486 47.3692H94.2081C92.9185 47.3692 91.8438 46.291 91.8438 44.9971C91.8438 43.7032 92.9185 42.625 94.2081 42.625H138.486C139.776 42.625 140.851 43.7032 140.851 44.9971C140.851 46.291 139.776 47.3692 138.486 47.3692Z",
    fill: "#CED7E2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.768 60.7403H94.2081C92.9185 60.7403 91.8438 59.6621 91.8438 58.3682C91.8438 57.0743 92.9185 55.9961 94.2081 55.9961H113.768C115.058 55.9961 116.132 57.0743 116.132 58.3682C115.917 59.6621 115.058 60.7403 113.768 60.7403Z",
    fill: "#CED7E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_282_10173",
    x: 0.379917,
    y: 9.67629,
    width: 260.146,
    height: 254.146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.7143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_282_10173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_282_10173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_282_10173",
    x: 42.919,
    y: 0.434099,
    width: 230.154,
    height: 257.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.7143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_282_10173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_282_10173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_282_10173",
    x: 30.3487,
    y: 9.24269,
    width: 210.057,
    height: 243.709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18.7143
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.7143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_282_10173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_282_10173",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.2394d8ec825d628dd322a47138bee5cd.svg";
export { ForwardRef as ReactComponent };